import React, { useEffect, useState } from "react";

import { getLoggedInUser } from "../helpers/fakebackend_helper";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const history = useNavigate();

  const [isDashboard, setIsDashboard] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const [isMaster, setIsMaster] = useState(false);

  const [isItem, setIsItem] = useState(false);
  const [isListItem, setIsListItem] = useState(false);
  const [isProcurement, setIsProcurement] = useState(false);
  const [isProcurementDetail, setIsProcurementDetail] = useState(false);

  const [isPeople, setIsPeople] = useState(false);
  const [isPaymentReport, setIsPaymentReport] = useState(false);
  const [isSetup, setIsSetup] = useState(false);
  const [isPayment, setIsPayment] = useState(false);
  const [isSales, setIsSales] = useState(false);
  const [isLogs, setIsLogs] = useState(false);
  const [isAccounting, setIsAccounting] = useState(false);
  const [isAcctReports, setIsAcctReports] = useState(false);
  const [isAcctSetup, setIsAcctSetup] = useState(false);

  const [isPaymentType, setIsPaymentType] = useState(false);
  const [isMenuCategory, setIsMenuCategory] = useState(false);
  const [isMenuItem, setMenuItem] = useState(false);
  const [isSetting, setIsSetting] = useState(false);
  const [isWaiter, setIsWaiter] = useState(false);
  const [isTable, setIsTable] = useState(false);
  const authUser = getLoggedInUser();
  // console.log("authUserr", authUser);
  const userRole = authUser?.user?.roles[0]?.toLowerCase();
  // console.log("🚀 ~ Navdata ~ userRole:", userRole);
  const isSuperAdmin = authUser.user.roles.includes("SuperAdmin");
  // const isSuperAdmin = true;
  // console.log("isSuperAdmin", isSuperAdmin);
  const isAdmin = true;

  const [iscurrentState, setIscurrentState] = useState("Dashboard");
  const [isCustomer, setIsCustomer] = useState(false); // inside User Management
  const [isProducts, setIsProducts] = useState(false);
  const [isCustomerSegments, setIsCustomerSegments] = useState(false); // inside Customer
  const [isVariants, setIsVariants] = useState(false); // inside Inventory Management
  const [isUnits, setIsUnits] = useState(false); // inside System Setup
  const [isTax, setIsTax] = useState(false); // inside System Setup
  const [isReportMgmt, setIsReportMgmt] = useState(false);
  const [isPaymentMgmt, setIsPaymentMgmt] = useState(false);
  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");

    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }

    if (iscurrentState !== "people-management") {
      setIsPeople(false);
    }

    if (iscurrentState !== "PaymentReport") {
      setIsPaymentReport(false);
    }

    if (iscurrentState !== "payment-type") {
      setIsPaymentType(false);
    }
    if (iscurrentState !== "menu-category") {
      setIsMenuCategory(false);
    }
    if (iscurrentState !== "menu-item") {
      setMenuItem(false);
    }

    if (iscurrentState !== "setting") {
      setIsSetting(false);
    }

    if (iscurrentState !== "settings") {
      setIsWaiter(false);
    }
    if (iscurrentState !== "Table") {
      setIsTable(false);
    }
    if (iscurrentState !== "sales-report") {
      setIsSales(false);
    }
    if (iscurrentState !== "logs") {
      setIsLogs(false);
    }
    if (iscurrentState !== "accounting") {
      setIsAccounting(false);
    }
    if (iscurrentState !== "user-management") {
      setIsUser(false);
    }
    if (iscurrentState !=="master-mgmt"){
      setIsMaster(false)
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
    isSetup,

    isPeople,

    isPaymentReport,

    isPaymentType,
    isMenuCategory,
    isMenuItem,
    isUser,
    isSetting,
    isWaiter,
    isTable,
    isSales,
    isLogs,
    isTax,
    isMaster
  ]);

  const orgMenuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
  {
      id: "master-mgmt",
      label: "Masters",
      icon: "ri-group-line",
      link: "/master-mgmt",
      parentId: "master-mgmt",
      stateVariables: isMaster,
      click: (e) => {
        e.preventDefault();
        setIsMaster(!isMaster);
        setIscurrentState("master-mgmt");
        updateIconSidebar(e);
      },
      subItems: [
      

        // Level 2 — plain leaves
        {
          id: "master-outlet",
          label: "Outlet",
          // icon: "ri-group-line",
          link: "/master-outlet",
        },
        {
          id: "master-cost-center",
          label: "Cost Center",
          // icon: "ri-apps-2-line",
          link: "/master-cost-center",
        },
      ],
    },
    // ── Dashboard ──────────────────────────────────────────────────
    {
      id: "Dashboard",
      label: "Dashboard",
      icon: "ri-dashboard-line",
      link: "/dashboard",
      click: (e) => {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
      },
    },

    // ── User Management ────────────────────────────────────────────
    {
      id: "user-management",
      label: "User Management",
      icon: "ri-group-line",
      link: "/user-management",
      parentId: "user-management",
      stateVariables: isUser,
      click: (e) => {
        e.preventDefault();
        setIsUser(!isUser);
        setIscurrentState("user-management");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "customer",
          label: "Customer",
          link: "/#",
          stateVariables: isCustomer,
          click: (e) => {
            e.preventDefault();
            setIsCustomer(!isCustomer);
          },
          subItems: [
            // Level 3 — plain leaves
            {
              id: "customer-list",
              label: "Customers",
              link: "/customer-list",
            },
            {
              id: "customer-type",
              label: "Customer Types",
              link: "/customer-type",
            },
            // {
            //   id: "customer-meta-fields",
            //   label: "Customer Meta Fields",
            //   link: "/customer-meta-fields",
            // },

            // Level 3 — nested further (Segments → VIP / Regular)
            // {
            //   id: "customer-segments",
            //   label: "Segments",
            //   link: "/#",
            //   stateVariables: isCustomerSegments,
            //   click: (e) => {
            //     e.preventDefault();
            //     setIsCustomerSegments(!isCustomerSegments);
            //   },
            //   subItems: [
            //     { id: "vip", label: "VIP Members", link: "/customer/segments/vip" },
            //     { id: "regular", label: "Regular", link: "/customer/segments/regular" },
            //   ],
            // },
          ],
        },

        // Level 2 — plain leaves
        {
          id: "staff",
          label: "Staffs",
          // icon: "ri-group-line",
          link: "/staff",
        },
        {
          id: "suppliers",
          label: "Suppliers",
          // icon: "ri-apps-2-line",
          link: "/suppliers",
        },
      ],
    },

    // ── Inventory Management ───────────────────────────────────────
    {
      id: "product-management",
      label: "Inventory Management",
      icon: "ri-restaurant-2-line",
      link: "/product-management",
      parentId: "product-management",
      stateVariables: isItem,
      click: (e) => {
        e.preventDefault();
        setIsItem(!isItem);
        setIscurrentState("product-management");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "menu-category",
          label: "Category",
          // icon: "bx bx-category",
          link: "/category-list",
        },
        // Level 2 — Products (has children)
        {
          id: "menu-item",
          label: "Products",
          // icon: "ri-apps-2-line",
          link: "/#",
          stateVariables: isProducts,
          click: (e) => {
            e.preventDefault();
            setIsProducts(!isProducts);
          },
          subItems: [
            {
              id: "menu-items-list",
              label: "Product List",
              link: "/menu-item",
            },

            {
              id: "receipe-management",
              label: "Recipes",

              link: "/receipe-management",
            },

          ],
        },

        {
          id: "purchase-group",
          label: "Purchases",
          link: "/#",
          stateVariables: isProcurementDetail,
          click: (e) => {
            e.preventDefault();
            setIsProcurementDetail(!isProcurementDetail);
          },
          subItems: [
            {
              id: "purchase",
              label: "Purchase List",
              link: "/purchase",
            },
            {
              id: "purchase-returns",
              label: "Purchase Returns",
              link: "/purchase-returns",
            },
          ],
        },
      ],
    },

    // ── Order Management ───────────────────────────────────────────
    {
      id: "order-management",
      label: "Order Management",
      icon: "ri-shopping-bag-line",
      link: "/order-management",
      parentId: "order-management",
      stateVariables: isListItem,
      click: (e) => {
        e.preventDefault();
        setIsListItem(!isListItem);
        setIscurrentState("order-management");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "order",
          label: "All Orders",
          link: "/order",
        },
        {
          id: "order-detail",
          label: "Order Details",
          link: "/order-detail",
        },
      ],
    },

    // ── Payment Records ────────────────────────────────────────────
    {
      id: "payment-record",
      label: "Finance",
      icon: "bx bxs-report",
      link: "/payment-record",
      parentId: "payment-record",
      stateVariables: isPayment,
      click: (e) => {
        e.preventDefault();
        setIsPayment(!isPayment);
        setIscurrentState("payment-record");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "payment-mgmt",
          label: "Payments",
          link: "/#",
          stateVariables: isPaymentMgmt,
          click: (e) => {
            e.preventDefault();
            setIsPaymentMgmt(!isPaymentMgmt);
          },
          subItems: [
            {
              id: "payment-statement",
              label: "Payment Statement",
              link: "/payment/statement",
            },
            { id: "day-book", label: "Day Book", link: "/day-book" },
            {
              id: "customer-payment",
              label: "Customer Receivable",
              link: "/customer-payment/collection",
            },

            {
              id: "supplier-payment",
              label: "Supplier Payment",
              link: "/supplier-payment",
            },
            {
              id: "supplier-pending",
              label: "Supplier Pending Payments",
              link: "/suppliers/pending",
            },
          ],
        },
        {
          id: "reports-mgmt",
          label: "Reports",
          link: "/#",
          stateVariables: isReportMgmt,
          click: (e) => {
            e.preventDefault();
            setIsReportMgmt(!isReportMgmt);
          },
          subItems: [
            {
              id: "credit-summary",
              label: "Credit Summary",
              link: "/credit-logs/summary",
            },
            {
              id: "sales-reports",
              label: "Sales Report",
              link: "/sales-report",
            },

            {
              id: "stock-summary",
              label: "Stock Summary",
              link: "/sales-report/wise",
            },
            {
              id: "return-bill-report",
              label: "Return Bill Report",
              link: "/return-bill-report",
            },
            {
              id: "transaction-report",
              label: "Transaction Report",
              link: "/transaction/report",
            },
            {
              id: "kitchen-report",
              label: "Kitchen order report",
              link: "/kitchen/report",
            },
            {
              id: "card-payment",
              label: "Card Payment Report",
              link: "/card-payment",
            },
          ],
        },
      ],
    },

    // ── Logs ───────────────────────────────────────────────────────
    {
      id: "logs",
      label: "Logs",
      icon: "bx bxs-report",
      link: "/logs",
      parentId: "logs",
      stateVariables: isLogs,
      click: (e) => {
        e.preventDefault();
        setIsLogs(!isLogs);
        setIscurrentState("logs");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "complimentry-logs",
          label: "Complimentary Logs",
          link: "/complimentry-logs",
        },
        { id: "day-book-logs", label: "Day Book Logs", link: "/logs/day-book" },
      ],
    },

    // ── Accounting ─────────────────────────────────────────────────
    {
      id: "accounting",
      label: "Accounting",
      icon: "ri-money-dollar-circle-line",
      link: "/accounting",
      parentId: "accounting",
      stateVariables: isAccounting,
      click: (e) => {
        e.preventDefault();
        setIsAccounting(!isAccounting);
        setIscurrentState("accounting");
        updateIconSidebar(e);
      },
      subItems: [
        { id: "vouchers", label: "Vouchers", link: "/vouchers" },
        // { id: "ledgers", label: "Ledgers", link: "/ledgers" },
        {
          id: "acct-setup",
          label: "Setup",
          link: "/#",
          stateVariables: isAcctSetup,
          click: (e) => {
            e.preventDefault();
            setIsAcctSetup(!isAcctSetup);
          },
          subItems: [
            { id: "fiscal-years", label: "Fiscal Years", link: "/fiscal-years" },
            { id: "ledger-types", label: "Ledger Types", link: "/ledger-types" },
            { id: "ledgers", label: "Ledgers", link: "/ledgers" },
            { id: "default-ledgers", label: "Default Ledger Settings", link: "/accounting/settings/default-ledgers" },
            { id: "auto-ledgers", label: "Auto Ledger Settings", link: "/accounting/settings/auto-ledgers" },
            { id: "payment-type-ledgers", label: "Payment Type Ledgers", link: "/accounting/settings/payment-type-ledgers" },
          ],
        },
        {
          id: "acct-reports",
          label: "Reports",
          link: "/#",
          stateVariables: isAcctReports,
          click: (e) => {
            e.preventDefault();
            setIsAcctReports(!isAcctReports);
          },
          subItems: [
            { id: "ledger-statement", label: "Ledger Statement", link: "/ledger-statement" },
            { id: "trial-balance", label: "Trial Balance", link: "/trial-balance" },
            { id: "balance-sheet", label: "Balance Sheet", link: "/balance-sheet" },
          ],
        },
      ],
    },

    // ── System Setup ───────────────────────────────────────────────
    {
      id: "Setup",
      label: "System Setup",
      icon: "ri-settings-3-line",
      link: "/setup",
      parentId: "Setup",
      stateVariables: isSetup,
      click: (e) => {
        e.preventDefault();
        setIsSetup(!isSetup);
        setIscurrentState("Setup");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "card-management",
          label: "Card Management",
          link: "/card-management",
        },
        { id: "payment-type", label: "Payment Types", link: "/payment-type" },
        { id: "section", label: "Section", link: "/section" },
        { id: "table", label: "Table", link: "/table" },
        {
          id: "units",
          label: "Units",
          link: "/#",
          stateVariables: isUnits,
          click: (e) => {
            e.preventDefault();
            setIsUnits(!isUnits);
          },
          subItems: [
            { id: "unit", label: "Unit", link: "/unit" },
            {
              id: "unitConversion",
              label: "Unit Conversion",
              link: "/unit-conversion",
            },
          ],
        },
        {
          id: "tax",
          label: "Tax",
          link: "/#",
          stateVariables: isTax,
          click: (e) => {
            e.preventDefault();
            setIsTax(!isTax);
          },
          subItems: [
            { id: "taxtype", label: "Tax Type", link: "/taxtype" },
          ],
        },
        { id: "cost-center", label: "Cost Center", link: "/cost-center" },
        {
          id: "discount-center",
          label: "Discount Center",
          link: "/discount-center",
        },
        {
          id: "feature-settings",
          label: "Features Settings",
          link: "/feature-settings",
        },
      ],
    },

    // ── Settings ───────────────────────────────────────────────────
    {
      id: "setting",
      label: "Settings",
      icon: "ri-settings-3-line",
      link: "/setting",
      parentId: "setting",
      stateVariables: isSetting,
      click: (e) => {
        e.preventDefault();
        setIsSetting(!isSetting);
        setIscurrentState("setting");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "generate-print-token",
          label: "Generate Print Token",
          link: "/generate-print-token",
        },
        {
          id: "customer-meta-fields",
          label: "Customer Meta Fields",
          link: "/customer-meta-fields",
        },
        { id: "clear-data", label: "Clear Data", link: "/clear-data" },
        {
          id: "download-template",
          label: "Download Template (Menu)",
          link: "/download-template",
        },
        {
          id: "import-template",
          label: "Import Template (Menu)",
          link: "/import-template",
        },
        {
          id: "data-seed",
          label: "Data Seed",
          link: "/data-seed",
        },
      ],
    },
  ];
  const superAdminItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "Dashboard",
      label: "Dashboard",
      icon: "ri-dashboard-line",
      link: "/dashboard",
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
      },
    },

    {
      id: "tenant",
      label: "Org Tenant",
      icon: "ri-apps-2-line",
      link: "/tenant",
      click: (e) => {
        e.preventDefault();
        handleMenuClick("tenant");
      },
    },
    {
      id: "email-config",
      label: "Email Configuration",
      icon: "ri-mail-line",
      link: "/email-configuration",
      click: (e) => {
        e.preventDefault();
        handleMenuClick("email-config");
      },
    },
    {
      id: "daily-stat-report",
      label: "Daily Stat Report",
      icon: "ri-file-chart-line",
      link: "/daily-stat-report",
      click: (e) => {
        e.preventDefault();
        handleMenuClick("daily-stat-report");
      },
    },
    {
      id: "kot-logs-request",
      label: "KOT Logs",
      icon: "ri-printer-line",
      link: "/kot-logs-request",
      click: (e) => {
        e.preventDefault();
        handleMenuClick("kot-logs-request");
      },
    },
      {
      id: "master-mgmt",
      label: "Masters",
      icon: "ri-group-line",
      link: "/master-mgmt",
      parentId: "master-mgmt",
      stateVariables: isMaster,
      click: (e) => {
        e.preventDefault();
        setIsMaster(!isMaster);
        setIscurrentState("master-mgmt");
        updateIconSidebar(e);
      },
      subItems: [
      

        // Level 2 — plain leaves
        {
          id: "master-outlet",
          label: "Outlet",
          // icon: "ri-group-line",
          link: "/master-outlet",
        },
        {
          id: "master-cost-center",
          label: "Cost Center",
          // icon: "ri-apps-2-line",
          link: "/master-cost-center",
        },
      ],
    },
  ];

  const cashierMenuItems = [
    {
      label: "Menu",
      isHeader: true,
    },

    // ── Dashboard ──────────────────────────────────────────────────
    {
      id: "Dashboard",
      label: "Dashboard",
      icon: "ri-dashboard-line",
      link: "/dashboard",
      click: (e) => {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
      },
    },

    // ── User Management ────────────────────────────────────────────
    {
      id: "user-management",
      label: "User Management",
      icon: "ri-group-line",
      link: "/user-management",
      parentId: "user-management",
      stateVariables: isUser,
      click: (e) => {
        e.preventDefault();
        setIsUser(!isUser);
        setIscurrentState("user-management");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "customer",
          label: "Customer",
          link: "/#",
          stateVariables: isCustomer,
          click: (e) => {
            e.preventDefault();
            setIsCustomer(!isCustomer);
          },
          subItems: [
            // Level 3 — plain leaves
            {
              id: "customer-list",
              label: "Customers",
              link: "/customer-list",
            },
            {
              id: "customer-type",
              label: "Customer Types",
              link: "/customer-type",
            },
            // {
            //   id: "customer-meta-fields",
            //   label: "Customer Meta Fields",
            //   link: "/customer-meta-fields",
            // },
            // Level 3 — nested further (Segments → VIP / Regular)
            // {
            //   id: "customer-segments",
            //   label: "Segments",
            //   link: "/#",
            //   stateVariables: isCustomerSegments,
            //   click: (e) => {
            //     e.preventDefault();
            //     setIsCustomerSegments(!isCustomerSegments);
            //   },
            //   subItems: [
            //     { id: "vip", label: "VIP Members", link: "/customer/segments/vip" },
            //     { id: "regular", label: "Regular", link: "/customer/segments/regular" },
            //   ],
            // },
          ],
        },

        // Level 2 — plain leaves
        {
          id: "staff",
          label: "Staffs",
          link: "/staff",
        },
        {
          id: "suppliers",
          label: "Suppliers",
          link: "/suppliers",
        },
      ],
    },

    // ── Inventory Management ───────────────────────────────────────
    {
      id: "product-management",
      label: "Inventory Management",
      icon: "ri-restaurant-2-line",
      link: "/product-management",
      parentId: "product-management",
      stateVariables: isItem,
      click: (e) => {
        e.preventDefault();
        setIsItem(!isItem);
        setIscurrentState("product-management");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "menu-category",
          label: "Category",
          // icon: "bx bx-category",
          link: "/category-list",
        },
        // Level 2 — Products (has children)
        {
          id: "menu-item",
          label: "Products",
          // icon: "ri-apps-2-line",
          link: "/#",
          stateVariables: isProducts,
          click: (e) => {
            e.preventDefault();
            setIsProducts(!isProducts);
          },
          subItems: [
            {
              id: "menu-items-list",
              label: "Product List",
              link: "/menu-item",
            },

            {
              id: "receipe-management",
              label: "Recipes",

              link: "/receipe-management",
            },
          ],
        },

        {
          id: "purchase-group",
          label: "Purchases",
          link: "/#",
          stateVariables: isProcurementDetail,
          click: (e) => {
            e.preventDefault();
            setIsProcurementDetail(!isProcurementDetail);
          },
          subItems: [
            {
              id: "purchase",
              label: "Purchase List",
              link: "/purchase",
            },
            {
              id: "purchase-returns",
              label: "Purchase Returns",
              link: "/purchase-returns",
            },
          ],
        },
      ],
    },

    // ── Order Management ───────────────────────────────────────────
    {
      id: "order-management",
      label: "Order Management",
      icon: "ri-shopping-bag-line",
      link: "/order-management",
      parentId: "order-management",
      stateVariables: isListItem,
      click: (e) => {
        e.preventDefault();
        setIsListItem(!isListItem);
        setIscurrentState("order-management");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "order",
          label: "All Orders",
          link: "/order",
        },
        {
          id: "order-detail",
          label: "Order Details",
          link: "/order-detail",
        },
      ],
    },

    // ── Payment Records ────────────────────────────────────────────
    {
      id: "payment-record",
      label: "Finance",
      icon: "bx bxs-report",
      link: "/payment-record",
      parentId: "payment-record",
      stateVariables: isPayment,
      click: (e) => {
        e.preventDefault();
        setIsPayment(!isPayment);
        setIscurrentState("payment-record");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "payment-mgmt",
          label: "Payments",
          link: "/#",
          stateVariables: isPaymentMgmt,
          click: (e) => {
            e.preventDefault();
            setIsPaymentMgmt(!isPaymentMgmt);
          },
          subItems: [
            {
              id: "payment-statement",
              label: "Payment Statement",
              link: "/payment/statement",
            },
            { id: "day-book", label: "Day Book", link: "/day-book" },
            {
              id: "supplier-pending",
              label: "Supplier Pending Payments",
              link: "/suppliers/pending",
            },
          ],
        },
        {
          id: "reports-mgmt",
          label: "Reports",
          link: "/#",
          stateVariables: isReportMgmt,
          click: (e) => {
            e.preventDefault();
            setIsReportMgmt(!isReportMgmt);
          },
          subItems: [
            {
              id: "credit-summary",
              label: "Credit Summary",
              link: "/credit-logs/summary",
            },
            {
              id: "sales-reports",
              label: "Sales Report",
              link: "/sales-report",
            },
            {
              id: "customer-payment",
              label: "Customer Payment",
              link: "/customer-payment/collection",
            },
            {
              id: "stock-summary",
              label: "Stock Summary",
              link: "/sales-report/wise",
            },
            {
              id: "return-bill-report",
              label: "Return Bill Report",
              link: "/return-bill-report",
            },
            {
              id: "transaction-report",
              label: "Transaction Report",
              link: "/transaction/report",
            },
            {
              id: "kitchen-report",
              label: "Kitchen order report",
              link: "/kitchen/report",
            },
          ],
        },
      ],
    },

    // ── Logs ───────────────────────────────────────────────────────
    {
      id: "logs",
      label: "Logs",
      icon: "bx bxs-report",
      link: "/logs",
      parentId: "logs",
      stateVariables: isLogs,
      click: (e) => {
        e.preventDefault();
        setIsLogs(!isLogs);
        setIscurrentState("logs");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "complimentry-logs",
          label: "Complimentary Logs",
          link: "/complimentry-logs",
        },
        { id: "day-book-logs", label: "Day Book Logs", link: "/logs/day-book" },
      ],
    },

    // ── Accounting ─────────────────────────────────────────────────
    {
      id: "accounting",
      label: "Accounting",
      icon: "ri-money-dollar-circle-line",
      link: "/accounting",
      parentId: "accounting",
      stateVariables: isAccounting,
      click: (e) => {
        e.preventDefault();
        setIsAccounting(!isAccounting);
        setIscurrentState("accounting");
        updateIconSidebar(e);
      },
      subItems: [
        { id: "vouchers", label: "Vouchers", link: "/vouchers" },
        { id: "ledgers", label: "Ledgers", link: "/ledgers" },
        {
          id: "acct-setup",
          label: "Setup",
          link: "/#",
          stateVariables: isAcctSetup,
          click: (e) => {
            e.preventDefault();
            setIsAcctSetup(!isAcctSetup);
          },
          subItems: [
            { id: "ledger-types", label: "Ledger Types", link: "/ledger-types" },
            { id: "fiscal-years", label: "Fiscal Years", link: "/fiscal-years" },
          ],
        },
        {
          id: "acct-reports",
          label: "Reports",
          link: "/#",
          stateVariables: isAcctReports,
          click: (e) => {
            e.preventDefault();
            setIsAcctReports(!isAcctReports);
          },
          subItems: [
            { id: "ledger-statement", label: "Ledger Statement", link: "/ledger-statement" },
            { id: "trial-balance", label: "Trial Balance", link: "/trial-balance" },
            { id: "balance-sheet", label: "Balance Sheet", link: "/balance-sheet" },
          ],
        },
      ],
    },

    // ── System Setup ───────────────────────────────────────────────
    {
      id: "Setup",
      label: "System Setup",
      icon: "ri-settings-3-line",
      link: "/setup",
      parentId: "Setup",
      stateVariables: isSetup,
      click: (e) => {
        e.preventDefault();
        setIsSetup(!isSetup);
        setIscurrentState("Setup");
        updateIconSidebar(e);
      },
      subItems: [
        { id: "payment-type", label: "Payment Types", link: "/payment-type" },
        { id: "section", label: "Section", link: "/section" },
        { id: "table", label: "Table", link: "/table" },
        {
          id: "units",
          label: "Units",
          link: "/#",
          stateVariables: isUnits,
          click: (e) => {
            e.preventDefault();
            setIsUnits(!isUnits);
          },
          subItems: [
            { id: "unit", label: "Unit", link: "/unit" },
            {
              id: "unitConversion",
              label: "Unit Conversion",
              link: "/unit-conversion",
            },
          ],
        },
        {
          id: "tax",
          label: "Tax",
          link: "/#",
          stateVariables: isTax,
          click: (e) => {
            e.preventDefault();
            setIsTax(!isTax);
          },
          subItems: [
            { id: "taxtype", label: "Tax Type", link: "/taxtype" },
          ],
        },
        
        { id: "cost-center", label: "Cost Center", link: "/cost-center" },
        {
          id: "discount-center",
          label: "Discount Center",
          link: "/discount-center",
        },
        {
          id: "feature-settings",
          label: "Features Settings",
          link: "/feature-settings",
        },
      ],
    },

    // ── Settings ───────────────────────────────────────────────────
    {
      id: "setting",
      label: "Settings",
      icon: "ri-settings-3-line",
      link: "/setting",
      parentId: "setting",
      stateVariables: isSetting,
      click: (e) => {
        e.preventDefault();
        setIsSetting(!isSetting);
        setIscurrentState("setting");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "generate-print-token",
          label: "Generate Print Token",
          link: "/generate-print-token",
        },
        // {
        //   id: "customer-meta-fields",
        //   label: "Customer Meta Fields",
        //   link: "/customer-meta-fields",
        // },
        { id: "clear-data", label: "Clear Data", link: "/clear-data" },
        {
          id: "download-template",
          label: "Download Template (Menu)",
          link: "/download-template",
        },
        {
          id: "import-template",
          label: "Import Template (Menu)",
          link: "/import-template",
        },
      ],
    },
  ];
  let filteredMenuItems;

  if (userRole === "superadmin") {
    filteredMenuItems = superAdminItems;
  } else if (userRole === "cashier") {
    filteredMenuItems = cashierMenuItems;
  } else {
    filteredMenuItems = orgMenuItems;
  }

  return <React.Fragment>{filteredMenuItems}</React.Fragment>;
};

export default Navdata;
